import type { AffiliateStockListing } from 'types/capi/pdp';

import Price from '~/components/Price';
import { getCheapestListing, getPriceForSize } from '~/utils/listings';

type Props = {
  listing: AffiliateStockListing;
  selectedSize?: string;
};

function getListingPrice(listing: AffiliateStockListing) {
  const isMarketplace = listing.affiliate.id === 'affiliate:marketplace';

  return isMarketplace
    ? (getCheapestListing(listing) ?? listing.price)
    : listing.price;
}

const ShippingAndPrice = ({ listing, selectedSize }: Props) => {
  const price =
    getPriceForSize(listing, selectedSize) ?? getListingPrice(listing);

  return (
    <div className="flex flex-col items-end justify-center">
      <div className="flex gap-1 text-base">
        <Price
          regular={price.regular}
          sale={price.sale}
          currency={price.currency}
          className="flex-col gap-0 text-base"
        />
      </div>
      {listing.affiliate.id === 'affiliate:marketplace' && (
        <p className="text-right text-xs font-normal text-grey-hide">
          incl. delivery & fees
        </p>
      )}
    </div>
  );
};

export default ShippingAndPrice;
